// @ts-strict-ignore
import React, { createContext } from 'react'

export const WalletControllerContext = createContext<WalletControllerProviderProps>(null)

interface WalletControllerProviderProps {
  children?: React.ReactNode
  isLoading: boolean
  isSuccess?: boolean
  hasErrors: boolean
  baseCurrency: string
  totalBalance: number
  totalFiat?: number
  totalCrypto?: number
}

export const WalletControllerProvider = ({
  children,
  isLoading,
  isSuccess,
  hasErrors,
  baseCurrency,
  totalBalance,
  totalFiat,
  totalCrypto,
}: WalletControllerProviderProps) => {
  return (
    <WalletControllerContext.Provider
      value={{
        isLoading,
        isSuccess,
        hasErrors,
        totalBalance,
        baseCurrency,
        totalFiat,
        totalCrypto,
      }}
    >
      {children}
    </WalletControllerContext.Provider>
  )
}
